export default __webpack_public_path__ + "static/media/delete-red.698f6fb6.svg";